<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageheader :title="title" :title1="title1" />
                <!-- /product list -->
                <div class="activity">
                    <div class="activity-box">
                        <ul class="activity-list">
                            <li v-for="(item, index) in data" :key="index">
                                <!-- <div class="activity-user">
                                    <router-link to="profile" title="" data-toggle="tooltip"
                                        data-original-title="Lesley Grauer">
                                        <img alt="Lesley Grauer" :src="require(`../../../assets/img/customer/${item.img}`)"
                                            class="img-fluid" />
                                    </router-link>
                                </div> -->
                                <a href="javascript:void(0);"
                                    class="text-secondary position-absolute top-0 end-0 me-2 mt-2">{{
                                        item.tanggal
                                    }}</a>
                                <span class="fw-bold">{{ item.judul }}</span>

                                <div class="timeline-content">

                                    <router-link to="profile" class="name">{{ item.konten }}</router-link>

                                </div>
                                <div class="activity-content">

                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, } from "@/assets/js/function";
import { watch } from 'vue';

export default {
    data() {
        return {
            data: [
                {
                    "id": 1,
                    "img": "profile3.jpg",
                    "name": "Elwis Mathew",
                    "product": "added a new product",
                    "phone": "Redmi Pro 7 Mobile",
                    "time": "4 mins ago"
                },

            ],
            title: "All Notifications",
            title1: "View all activities",

            //data
            api: "",
            config: "",
        };
    },
    name: "activities",

    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }

        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')

        
        this.index();
    },

    mounted() {
        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })
    },
    
    methods: {
        async index() {
           
            let formData = new FormData();
            appendForm(formData);

            formData.append("jenis", "notifikasi");

            

            console.log('ini filter :', this.filter)

            const api = base_url + '/v3/notification/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            const notif = data.data.data_notifikasi;
            console.log('ini data notifikasi:', data)
            
            if(data.status){

                this.data = notif;
                
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
                // this.loading = false;

            }

            
           

        },
    }
};
</script>